import { useState } from "react";
import { CheckCircle, Circle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const STAGES = [
  { id: "osint", label: "OSINT" },
  { id: "validation", label: "Target validation" },
  { id: "test_purchase", label: "Test purchase" },
  { id: "enforcement", label: "Enforcement" },
  { id: "closed", label: "Closure" },
];

/**
 * Stage progress bar for investigation-lifecycle cases (INV/INF/FIR/FoR).
 * Renders nothing for other case codes.
 */
export default function StageProgressBar({ caseId, code, current, canEdit, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!["INV","INF","FIR","FoR"].includes(code)) return null;
  const activeIdx = STAGES.findIndex(s => s.id === current);
  const advance = async (stageId) => {
    if (!canEdit) return;
    setBusy(true);
    try {
      await api.put(`/cases/${caseId}/stage?stage=${stageId}`);
      onChanged && onChanged(stageId);
    } finally { setBusy(false); }
  };
  return (
    <div className="card-flat p-4" data-testid="stage-progress-bar">
      <div className="label-eyebrow mb-2">Investigation lifecycle</div>
      <ol className="flex items-center gap-1">
        {STAGES.map((s, i) => {
          const done = activeIdx > i;
          const active = activeIdx === i;
          return (
            <li key={s.id} className="flex-1">
              <button
                disabled={!canEdit || busy}
                onClick={() => advance(s.id)}
                data-testid={`stage-${s.id}`}
                className={`w-full p-2 hairline text-[11px] flex items-center gap-1.5 cursor-pointer ${
                  active ? "bg-emerald-50 border-emerald-400 font-bold" : done ? "bg-emerald-50/40" : "hover:bg-[var(--span-surface-2)]"
                } ${!canEdit && "cursor-default"}`}>
                {done || active ? <CheckCircle size={12} weight={active ? "fill" : "regular"} className="text-emerald-600"/> : <Circle size={12}/>}
                <span>{i+1}. {s.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
      {canEdit && <div className="text-[10px] text-[var(--span-text-2)] mt-1.5">Click a stage to advance the case.</div>}
    </div>
  );
}
